(() => {
  if (!customElements.get('ns-premium-film')) customElements.define('ns-premium-film', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.ns-film__player');
      this.querySelectorAll('[data-film-open]').forEach(button => button.addEventListener('click', () => this.openFilm(button)));
      this.querySelector('[data-film-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.cleanup());
    }
    openFilm(button) {
      this.opener = button;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      const error = this.querySelector('.ns-film__error');
      error.hidden = true;
      if (!this.player.querySelector('video')) this.player.append(this.querySelector('[data-film-template]').content.cloneNode(true));
      const video = this.player.querySelector('video');
      if (!video) { error.hidden = false; return; }
      video.addEventListener('error', () => { error.hidden = false; }, {once: true});
      video.play().catch(() => { /* Native play control remains available if autoplay is blocked. */ });
    }
    cleanup() {
      this.player.querySelector('video')?.pause();
      this.player.replaceChildren();
      document.documentElement.style.overflow = this.previousOverflow || '';
      if (this.opener?.isConnected) this.opener.focus({preventScroll: true});
    }
    disconnectedCallback() { if (this.dialog?.open) { this.dialog.close(); this.cleanup(); } }
  });
  if (!customElements.get('ns-premium-faq')) customElements.define('ns-premium-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelectorAll('[data-faq-filter]').forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-faq-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.querySelectorAll('[data-faq-category]').forEach(item => { item.hidden = button.dataset.faqFilter !== 'all' && item.dataset.faqCategory !== button.dataset.faqFilter; });
      }));
      this.addEventListener('shopify:block:select', event => {
        this.querySelector('[data-faq-filter="all"]').click();
        const detail = event.target.closest('details');
        if (detail) detail.open = true;
      });
    }
  });
})();
